
import { computed, defineComponent, PropType } from 'vue';
import { DrugCovariate } from '@/service/models/response/drug-model-detail/covariate/drug-covariate';
import CovariateStandardDateValue from './covariate-values/CovariateStandardDateValue.vue';
import CovariateStandardValue from './covariate-values/CovariateStandardValue.vue';
import CovariateSexValue from './covariate-values/CovariateSexValue.vue';
import { useRequestDataStore } from '@/store/request-data';

export default defineComponent({
    components: {
        CovariateSexValue,
        CovariateStandardDateValue,
        CovariateStandardValue,
    },

    props: {
        covariate: {
            type: Object as PropType<DrugCovariate>,
            required: true,
        },
    },

    setup(props)
    {
        const requestData = useRequestDataStore();

        const currentValue = computed(() => {
            return requestData.getCovariateValueAt(props.covariate, new Date());
        });

        const isSexCovariate = computed(() => props.covariate.type === DrugCovariate.Type.SEX);
        const isDateCovariate = computed(() => props.covariate.dataType === DrugCovariate.DataType.DATE);
        const isStandardCovariate = computed(() => {
            return (
                props.covariate.type === DrugCovariate.Type.STANDARD ||
                props.covariate.type === DrugCovariate.Type.AGE_IN_YEARS ||
                props.covariate.type === DrugCovariate.Type.AGE_IN_MONTHS ||
                props.covariate.type === DrugCovariate.Type.AGE_IN_WEEKS ||
                props.covariate.type === DrugCovariate.Type.AGE_IN_DAYS
            );
        });

        return {
            currentValue,

            isSexCovariate,
            isDateCovariate,
            isStandardCovariate,
        };
    },
})
